export const contextIcons: { [key: string]: string } = {
  // 'Traveling': '✈️',
  // 'Museum': '🏛️',
  'Cooking': '👨‍🍳',
  // 'Olympic Games': '🏅',
  'Superheroes': '🦸‍♀️',
  'Science Fiction': '🛸',
  // 'Mythology': '🧙',
  'Game of Chance': '🎰',
  'Board Games': '🎲',
  // 'Sustainability': '♻️',
};

export const contexts = [
  // "Traveling",
  // "Museum",
  "Cooking",
  // "Olympic Games",
  "Superheroes",
  "Science Fiction",
  // "Mythology",
  "Game of Chance",
  "Board Games",
  // "Sustainability",
];